/**
 * Port de invalidación de read models consolidados.
 *
 * Los write paths (settings/infra, mercadopago, delivery zones) no pueden
 * importar los repos de snapshot (shell/home, onboarding) sin invertir la
 * dependencia. En cambio llaman a los invalidators de `storefrontStatusCache`
 * — como siempre — y esos disparan este registry.
 *
 * Los repos de read model se auto-registran al evaluarse: si el módulo nunca
 * se importó, su cache está vacío y no hace falta invalidar nada.
 */

export type StorefrontChangeScope = 'profile' | 'zones' | 'mp';

/** branchId null = se desconoce la branch afectada → invalidar todo. */
type StorefrontInvalidator = (
  branchId: string | null,
  scope: StorefrontChangeScope,
) => void;

const storefrontInvalidators: StorefrontInvalidator[] = [];

export function registerStorefrontReadModelInvalidator(
  fn: StorefrontInvalidator,
): () => void {
  storefrontInvalidators.push(fn);
  return () => {
    const i = storefrontInvalidators.indexOf(fn);
    if (i >= 0) storefrontInvalidators.splice(i, 1);
  };
}

export function runStorefrontReadModelInvalidators(
  branchId: string | null,
  scope: StorefrontChangeScope,
): void {
  for (const fn of storefrontInvalidators) {
    try {
      fn(branchId, scope);
    } catch {
      // Best-effort: un listener roto no bloquea la invalidación de otros.
    }
  }
}
